import React, {useEffect} from "react";

export default function Inscripcion() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://formfacade.com/include/101726630360237549223/form/1FAIpQLSd2waLlyU-x3Jrbh4Mwulc-6iEZ-DV1BhIV3X78D9g7SacpOA/classic.js?div=ff-compose"
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    
    return (
        <div id="contacto">
            <div className='destacado'>
                <h1>Inscripción</h1>

                <p>Para acceder a nuestras clases y/o concursos, debes inscribirte a través del siguiente formulario y cumplir con los requisitos explicados en la página de Inicio. Recuerda que los datos que pongas, como los estudios que estás cursando en tu centro, deben corresponder al curso 2025/26.</p>

                <p>Si no, no obtendrás acceso a estos.</p>

                <p>Importante: debes rellenar todas las casillas del formulario para que este se envíe.</p>
            </div>
            <div id='ff-compose'></div>
        </div>
    );
}